import { Component, Input } from "@angular/core";

@Component({
  selector: "app-icon-view-news",
  imports: [],
  templateUrl: "./icon-view-news.component.html",
  styleUrl: "./icon-view-news.component.scss",
})
export class IconViewNewsComponent {
  @Input() color = "#000";
}
